import * as types from '../constants/idpAdminActions';
import {
  addAzureAdApi,
  deleteAzureAdApi,
  getAzureAdJsonApi,
  getAzureAdListApi
} from "../api/api";
import {
  DELETE_AZURE_AD_FAIL,
  DELETE_AZURE_AD_FAIL_NOT_FOUND,
  DELETE_AZURE_AD_OK
} from "../constants/postMessages";
import {getOrigin, getSessionToken} from "./storage";

/*
 * addAzureAd
 */
export function addAzureAd(addAzureAdData) {
  return (dispatch) => {
    dispatch(addAzureAdStart());
    return addAzureAdApi(addAzureAdData)
    .then(response => {
      dispatch(getAzureAdJson());
      dispatch(addAzureAdSuccess(response));
    })
    .catch((error) => {
      dispatch(addAzureAdFail(error.response));
    });
  }
}

export const addAzureAdStart = () => ({
  type: types.ADD_AZURE_AD_START
});

export const addAzureAdSuccess = (response) => ({
  type: types.ADD_AZURE_AD_SUCCESS,
  response
});

export const addAzureAdFail = (errorMsg) => ({
  type: types.ADD_AZURE_AD_FAIL,
  errorMsg
});

/*
 * deleteAzureAd
 */
export function deleteAzureAd(id) {
  console.log("Deleting Azure AD with internal ID of " + id);
  return (dispatch) => {
    if (getSessionToken()) {
      dispatch(deleteAzureAdStart());
      return deleteAzureAdApi(id)
      .then(response => {
        if (response.status === 200) {
          window.parent.postMessage(DELETE_AZURE_AD_OK, getOrigin());
          dispatch(deleteAzureAdSuccess(response));
        } else {
          // Handle error in response
          let consoleMsg = "Failed to delete Azure AD with internal ID of " + id
              + ". ";
          let parentMsg = "";
          if (response.status === 404) {
            consoleMsg += "Cannot find Azure AD.";
            parentMsg = DELETE_AZURE_AD_FAIL_NOT_FOUND;
          } else {
            consoleMsg += "Response was '" + response + "'";
            parentMsg = DELETE_AZURE_AD_FAIL;
          }
          console.error(consoleMsg);
          window.parent.postMessage(parentMsg, getOrigin());
          dispatch(deleteAzureAdFail());
        }
      })
      .then(() => {
        dispatch(getAzureAdList());
      })
      .catch((error) => {
        console.error(error);
        window.parent.postMessage(DELETE_AZURE_AD_FAIL, getOrigin());
        dispatch(deleteAzureAdFail());
      });
    }
  }
}

export const deleteAzureAdStart = () => ({
  type: types.DELETE_AZURE_AD_START
});

export const deleteAzureAdSuccess = () => ({
  type: types.DELETE_AZURE_AD_SUCCESS
});

export const deleteAzureAdFail = () => ({
  type: types.DELETE_AZURE_AD_FAIL
});

/*
 * getAzureAdList
 */
export function getAzureAdList() {
  return (dispatch) => {
    if (getSessionToken()) {
      dispatch(getAzureAdListStart());
      return getAzureAdListApi()
      .then(response => {
        dispatch(getAzureAdListSuccess(response));
      })
      .catch((error) => {
        dispatch(getAzureAdListFail(error.message));
      });
    }
  }
}

export const getAzureAdListStart = () => ({
  type: types.GET_AZURE_AD_LIST_START
});

export const getAzureAdListSuccess = (response) => ({
  type: types.GET_AZURE_AD_LIST_SUCCESS,
  response
});

export const getAzureAdListFail = (errorMsg) => ({
  type: types.GET_AZURE_AD_LIST_FAIL,
  errorMsg,
});

/*
 * getAzureAdJson
 */
export function getAzureAdJson() {
  return (dispatch) => {
    if (getSessionToken()) {
      dispatch(getAzureAdJsonStart());
      return getAzureAdJsonApi()
      .then(response => {
        //using a string prefix here to indicate the incoming JSON
        //will be captured and parsed out when received
        //note: due to IE9 restriction, we can only send a string here, not an object.
        window.parent.postMessage("azureADJSON: " + JSON.stringify(response),
            getOrigin());
        dispatch(getAzureAdJsonSuccess(response));
      })
      .catch((error) => {
        dispatch(getAzureAdJsonFail(error.message));
      });
    }
  }
}

export const getAzureAdJsonStart = () => ({
  type: types.GET_AZURE_AD_JSON_START
});

export const getAzureAdJsonSuccess = (response) => ({
  type: types.GET_AZURE_AD_JSON_SUCCESS,
  response
});

export const getAzureAdJsonFail = (errorMsg) => ({
  type: types.GET_AZURE_AD_JSON_FAIL,
  errorMsg,
});
